import { createContext, useState, useEffect } from "react";

import {
  localStore,
  swStartWebRTC,
  swDisconnect,
} from "./evoSwClient-1.0.25.systech";

export const exmAddress =
  process.env.REACT_APP_API_EXM_URL || "https://swdemo.evostream.com:5555";

const localPeerOptions = {
  offerOptions: {
    offerToReceiveAudio: true,
    offerToReceiveVideo: true,
  },
  config: {
    sdpSemantics: "unified-plan",
  },
};

// exm session config
export const exmParams = {
  session: process.env.REACT_APP_API_BASE_SESSION,
  email: process.env.REACT_APP_API_BASE_EMAIL,
  password: process.env.REACT_APP_API_BASE_PASSWORD,
  features: {
    availability: true,
  },
};

export const WebrtcContext = createContext();

const WebrtcProvider = ({ children }) => {
  const [viewerOptions, setViewerOptions] = useState(null);
  const [first, setAFirst] = useState(true);
  const [peers, setPeers] = useState([]);
  const [streamActive, setStreamActive] = useState({});
  const [streamActiveListe, setStreamActiveList] = useState([]);
  const [isConnectedEXM, setIsConnected] = useState(false);
  const [cmdStatus, setCmdStatus] = useState("none");
  const [currentCmd, setCurrentCmd] = useState("none");
  const [peerSession, setPeerSession] = useState([]);
  const [currentVideo, setCurr] = useState({});
  const [streamReadyToPlay, setStreamReadyToPlay] = useState(false);

  const setCurrentVideo = (a) => setCurr(a);

  const handleStartPeerSession = async (id) => {
    const _s = await localStorage.getItem("_session_");
    const _session = [...JSON.parse(_s), id];
    setPeerSession(_session);
    await localStorage.setItem("_session_", JSON.stringify(_session));
  };

  const handlePeerAvailability = (param) => {
    console.log(`Availability`);
    console.log(param);
  };

  const handleDiscoveredPeer = async (data) => {
    const _peerData = Array.from(localStore.remotePeers.values());
    setPeers(_peerData);
  };

  const handleDiscoveredListPeer = async (data) => {
    const _peerData = Array.from(localStore.remotePeers.values());
    setPeers(_peerData);
  };

  const handleDeletedPeer = async (data) => {
    const _s = await localStorage.getItem("_session_");
    const _session = [...JSON.parse(_s).filter((iii) => iii != data.clientid)];
    setPeerSession(_session);
    handleUpdateListActiveStream();
    await localStorage.setItem("_session_", JSON.stringify(_session));
    const _peerData = Array.from(localStore.remotePeers.values());
    setPeers(_peerData);
  };

  const handlePeerConnected = (remotePeer) => {
    console.log(`Peer connected! ${JSON.stringify(remotePeer)}`);
  };

  const handlePeerData = (param) => {
    const data = String.fromCharCode.apply(null, param.data);
    // Check if this is a response from the camera
    const cameraResponse = "cameraResponse:";
    setCmdStatus("none");
    if (data.includes(cameraResponse)) {
      console.log(" cameraResponse: ", data.substring(cameraResponse.length));
      setCmdStatus("succes");
    }
  };

  const handlePlayStream = async (clientid, streamName) => {
    const remotePeer = localStore.getRemotePeer(clientid);
    await localStore.playStream(remotePeer, streamName);
    handleUpdateListActiveStream();
  };

  const handleStopStream = async (clientid, streamName) => {
    const remotePeer = localStore.getRemotePeer(clientid);
    await localStore.removeActiveStream(remotePeer, streamName);
    handleUpdateListActiveStream();
  };

  const handleSetStreamList = async (data) => {
    handleUpdateListActiveStream();
    const _peerData = Array.from(localStore.remotePeers.values());
    setPeers(_peerData);
  };

  const handleAddStreamToList = async (data) => {
    if (streamActive?.includes(data.streamName)) {
      setStreamActive(streamActive.filter((i) => i !== data.streamName));
    }
  };

  const handleRemoveStreamFromList = (data) => {
    // console.log("handleRemoveStreamFromList ----", data);
    handleUpdateListActiveStream();
  };

  const handleUpdateListActiveStream = () => {
    setStreamActiveList([...Array.from(localStore.activeStreams.values())]);
  };

  const handleAddActiveStream = (data) => {
    handleUpdateListActiveStream();
    setStreamActive(data);
  };

  const sendCommandRq = (clientid, cmd, name) => {
    setCmdStatus("request");
    setCurrentCmd(name);
    localStore.sendCommand(clientid, cmd);
  };

  const swEventHandler = (event, data) => {
    switch (event) {
      case "discoveredPeer":
        handleDiscoveredPeer(data);
        break;

      case "deletedPeer":
        handleDeletedPeer(data);
        break;

      case "peerConnected":
        handlePeerConnected(data);
        break;

      case "peerData":
        handlePeerData(data);
        break;

      case "setStreamList":
        handleSetStreamList(data);
        break;

      case "addStreamToList":
        handleAddStreamToList(data);
        break;

      case "removeStreamFromList":
        handleRemoveStreamFromList(data);
        break;

      case "addActiveStream":
        handleAddActiveStream(data);
        break;

      case "peerAvailability":
        handlePeerAvailability(data);
        break;

      case "viewerOptions":
        setViewerOptions(data);
        break;
      case "streamPeerReady":
        setStreamReadyToPlay(data);
        break;
      case "loggedIn":
        setIsConnected(true);
        break;

      case "startPeerSession":
        data?.remotePeer?.clientid &&
          handleStartPeerSession(data.remotePeer.clientid);
        break;

      case "removeActiveStream":
        setStreamActive({});
        break;

      case "discovery":
        handleDiscoveredListPeer(data);
        break;

      default:
        console.log(`EVENT: ${event}`);
        if (data !== undefined) {
          console.log(`DATA: ${JSON.stringify(data)}`);
        }
        break;
    }
  };
  useEffect(() => {
    async function init() {
      setAFirst(false);
      if (first) return null;
      await localStorage.clear();
      localStore && localStore.subscribe(swEventHandler);
      !first && swStartWebRTC(exmParams, localPeerOptions, exmAddress, false);
    }
    init();
  }, [first]);

  useEffect(
    () => () => {
      console.log("cleaned up");
      swDisconnect && swDisconnect();
    },
    []
  );

  return (
    <WebrtcContext.Provider
      value={{
        handlePlayStream,
        sendCommandRq,
        handleStopStream,
        setCurrentVideo,
        handleAddActiveStream,
        streamActiveListe,
        currentVideo,
        peerSession,
        currentCmd,
        cmdStatus,
        peers,
        streamActive,
        isConnectedEXM,
        viewerOptions,
        streamReadyToPlay,
      }}
    >
      {children}
    </WebrtcContext.Provider>
  );
};

export default WebrtcProvider;
